<template>
  <div>
    <div ref="chart" style="width: 100%; height: 400px"></div>
  </div>
</template>

<script>
import echarts from "echarts";
import { getPriceChart } from "@/assets/js/api";
let myChart = null;
export default {
  name: "LineChart",
  props: {
    productInfo: null,
  },
  watch: {
    productInfo(newVal, oldVal) {
      this.getPriceChartData(newVal);
    },
  },
  mounted() {
    this.initChart();
  },
  data() {
    return {
      formData: {
        websiteid: "",
        market: "",
        product: "",
        takeCount:30
      },
      PriceChart: [],
      // 配置图表的选项
      option: {
        color: "#0accb9",
        legend: {
          style: {
            borderColor: "green",
            borderWidth: "1px",
            borderRadius: "5px",
            padding: "10px",
          },
        },
        tooltip: {
          style: {
            borderColor: "#0accb9",
            backgroundColor: "#0accb9",
          },
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
          backgroundColor: '#0accb9'
        }
          },
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "价格(元/公斤)",
            type: "line",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
          },
        ],
      },
    };
  },
  created() {
    this.getPriceChartData(this.productInfo);
  },
  methods: {
    initChart() {
      const chartDom = this.$refs.chart;
      myChart = echarts.init(chartDom);
      // 使用刚指定的配置项和数据显示图表。
    },
    // 农产品价格趋势弹窗折线图
    getPriceChartData(productInfo) {
      this.formData.websiteid = productInfo.websiteid;
      this.formData.market = productInfo.market;
      this.formData.product = productInfo.proName;
      this.formData.takeCount = 30
      getPriceChart(this.formData).then((res) => {
        if (res.code === 200) {
          //一级分类
          // console.log(res.data.chartData);
          let chartData = res.data.chartData;
          const keys = Object.keys(chartData);
          this.option.xAxis.data = keys;
          for (let i = 0; i < keys.length; i++) {
            this.option.series[0].data[i] = chartData[keys[i]].price;
          }
          myChart.setOption(this.option);
        }
      });
    },
  },
};
</script>
